import { Component, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { knowledgeOptions } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'financial-knowledge4',
    templateUrl: './financial-knowledge4.component.html',
    styleUrls: ['./financial-knowledge4.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class FinancialKnowledge4Component implements OnInit {
  options: FormControlOption[] = knowledgeOptions;
  constructor() {}

  ngOnInit() {}
}
